export function classNames(...xs) {
	return xs.filter(Boolean).join(' ');
}

export default classNames;